/** Links e dados de contato — fonte única para o portfólio */
export const CONTACT = {
  email: 'alexandre10y@outlook.com',
  emailDisplay: 'alexandre10y@Outlook.com',
  github: 'https://github.com/Alexandre10y',
  githubHandle: '/Alexandre10y',
  linkedin: 'https://www.linkedin.com/in/alexandre10y/',
  linkedinHandle: '/in/alexandre10y',
  instagram: 'https://www.instagram.com/alexandre10y/',
  instagramHandle: '@alexandre10y',
  whatsapp: 'https://wa.me/554284022669',
  whatsappDisplay: '(42) 98402-2669',
};

/** Formulário de inscrição — Imersão em IA para Professores (Google Forms) */
export const INSCRICAO = {
  formUrl:
    'https://docs.google.com/forms/d/1wqd9SItNtQkmE6lb0yKDGUrI_KCDbHla5zrkVC-klvI/viewform',
  formLabel: 'Quero me inscrever',
};
